import $ from "jquery";

const validators = {
    select: {
        parameters: ["minSelected", "selectStyle"],
        isValid: function (value, element, params) {
            if (params.selectStyle == "Search") {
                var elementId = element.id || "";
                var baseId = elementId.endsWith("_visible") ? elementId.replace("_visible", "") : elementId;
                var listElement = $("#" + baseId + "_SearchList");
                var validValues = [];
                var validTexts = [];

                listElement.children().each(function () {
                    validValues.push((($(this).data("select-list-value") ?? "") + "").toLowerCase());
                    validTexts.push((($(this).data("select-list-text") ?? "") + "").toLowerCase());
                });

                var testValue = ((value ?? "") + "").toLowerCase();
                return testValue == "" || validValues.includes(testValue) || validTexts.includes(testValue);
            }

            if (params.selectStyle == "MultiSelect") {
                var minSelected = parseInt(params.minSelected, 10) || 0;
                if (minSelected === 0)
                    return true;

                var checkedCount = $('input[name="' + element.name + '"]:checked').length;

                return checkedCount >= minSelected;
            }

            return true;
        },
        unpack: function (options) {
            options.rules["select"] = options.params;
            options.messages["select"] = options.message;
        }
    }
};

function setupSelect() {
    $('[id$="_SearchList"]').each(function () {
        var hiddenInputElem = $("#" + this.id.replace("_SearchList", ""));
        var visibleInputElem = $("#" + this.id.replace("_SearchList", "") + "_visible");
        var listElement = $(this);
        var listChildren = listElement.children('.list-group-item');

        function setHiddenValue(value) {
            var newValue = value ?? "";
            var previousValue = hiddenInputElem.val() ?? "";
            hiddenInputElem.val(newValue);

            if (previousValue != newValue) {
                hiddenInputElem.trigger("change");
            }

            hiddenInputElem.valid();
        }

        visibleInputElem.on("focus", function () {
            listElement.fadeIn("quick");
            filterListElements(listChildren, visibleInputElem.val().toLowerCase())
        })

        visibleInputElem.on("focusout", function () {
            listElement.fadeOut("quick");
            hiddenInputElem.valid();
        })

        visibleInputElem.on("input", function (event) {
            filterListElements(listChildren, event.target.value.toLowerCase())

            var matchingOption = listChildren
                .toArray()
                .find((item) => (($(item).data("select-list-text") ?? "") + "").toLowerCase() === event.target.value.toLowerCase());

            setHiddenValue(matchingOption ? $(matchingOption).data("select-list-value") : "");
        })

        listChildren.on("mousedown", function () {
            visibleInputElem.val($(this).data("select-list-text"));
            setHiddenValue($(this).data("select-list-value"));
        })
    })

    $('[data-select-container]').on('click', function () {
        const clickedDropdown = this;
        closeAllMultiSelects(clickedDropdown);
        toggleMultiSelect(clickedDropdown);
    });

    $('[data-select-options] label').on('click', function () {
        var options = $(this).closest('[data-select-options]');
        var container = options.siblings('[data-select-container]');
        var checkedOptions = options.find('label input:checked');

        var text;
        if (checkedOptions.length == 0) {
            text = container.data('select-none');
        } else if (checkedOptions.length == 1) {
            text = $(checkedOptions[0]).next().text();
        } else {
            text = container.data("select-multiple");
        }

        container.find('span').text(text);
    });

    $('body').on('click', function (e) {
        if ($(e.target).closest('[data-select-container], [data-select-options]').length) {
            return;
        }
        closeAllMultiSelects()
    });
}

function filterListElements(listElements, value) {
    var searchValue = (value || "").toLowerCase();

    listElements.each(function () {
        highlightMatchingText($(this), $(this).data("select-list-text"), searchValue)
    });
}

function highlightMatchingText(listItem, text, query) {
    var lowerText = text.toLowerCase();
    var isMatch = lowerText.includes(query);
    var currentIndex = 0;
    var content = $(document.createDocumentFragment());
    
    if (isMatch && query.length > 0) {
        var matchIndex = lowerText.indexOf(query);

        while (matchIndex != -1) {
            content.append(document.createTextNode(text.substring(currentIndex, matchIndex)));
            $("<span>")
                .addClass("search-list-match")
                .text(text.substring(matchIndex, matchIndex + query.length))
                .appendTo(content);

            currentIndex = matchIndex + query.length;
            matchIndex = lowerText.indexOf(query, currentIndex);
        }
    }

    content.append(document.createTextNode(text.substring(currentIndex)));
    listItem.toggleClass("d-none", !isMatch);
    listItem.empty().append(content);
}

function closeAllMultiSelects(except) {
    $('[data-select-container].focused').not(except).each(function () {
        toggleMultiSelect(this);
    });
}

function toggleMultiSelect(container) {
    $(container).toggleClass('focused');
    var target = $(container).data('options-target');
    $(target).toggleClass('d-none');
}

export { validators, setupSelect };